import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { DECORATIONS_LIST_MAP_VALUE_TO_LABEL } from './constants';

export const decorationsListTagsManager = createTermsTagsManager({
  jsonQueryKey: 'decorations_list',
  mapValueToLabel: DECORATIONS_LIST_MAP_VALUE_TO_LABEL,
  id: 'decorationsList',
});
